module.exports = "/assets/data/2cadacb6f798319f923ba8d037580650-M60.data.json";